import React from 'react';
import styled from 'styled-components';
import mondrian from 'core/config/theme';

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: ${mondrian.spacingStackSm} 0;

  .mdn-Button {
    margin-bottom: ${mondrian.spacingStackSm};
  }
`;

export default function InputGroup(props) {
  return <Div>{props.children}</Div>;
}
